import React, { useState, useEffect } from 'react';
import { styled } from "@mui/system";
import Box from '@mui/material/Box';
import { Stepper, Step, StepLabel, StepConnector } from "@mui/material";
import { fetchData } from "../func/api";

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-line": {
    borderWidth: 5,
  },
}));

export default function ReportTimeline({activeStep}) {

  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    // 報告ステータス一覧取得
    const getStatusOptions = async () => {
      const options = await fetchData("api/get_report_status_without_midway/");
      const updatedOptions = options.map(option => ({
        ...option,
        name: option.name === '初動対応' ? '初動対応' : option.name === '第1報報告済' ? '第1報' : option.name === '１次点検報告済' ? '１次点検' : option.name === '２次点検報告済' ? '２次点検' : option.name
      }));
      setStatusOptions(updatedOptions);
    };
    getStatusOptions();
  }, []);

  // activeStep に対応するインデックスを取得
  const activeIndex = statusOptions.findIndex(option => option.uuid === activeStep);
  return (
      <Box sx={{ width: '100%' }}>
        <Stepper activeStep={activeIndex + 1} alternativeLabel connector={<CustomStepConnector />}>
          {statusOptions.map((option) => (
            <Step key={option.uuid}>
              <StepLabel
                sx={{
                  "& .MuiStepLabel-label": {
                    fontSize: "1.2rem",
                    fontWeight: "bold !important",
                  },
                  "& .MuiStepIcon-root": {
                    fontSize: '2.3rem',
                  },
                }}
              >
                {option.name}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
    );
}